<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="umUGXVdQVzPJsKIMkLfBTx4">
<p class="Normal ParaOverride-2"><br/></p>
<p class="Normal ParaOverride-2"><br/></p>
<p class="Normal ParaOverride-2">In Memory of Duane Hillaby</p>
<p class="Normal ParaOverride-2">This book was always for you, brother.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?7a11dda5